import { useMemo } from 'react';

import { usePaypal } from '#src/app/shared/hooks/payments';
import { isLoaded } from '#src/app/shared/utils/async';
import type { PaymentType } from '#src/app/shared/utils/payments';

type Result = (paymentType: PaymentType) => { deviceData: string } | undefined;

export function useDeviceData(): Result {
	const paypalSdk = usePaypal();

	const deviceData = useMemo(() => {
		if (isLoaded(paypalSdk)) return paypalSdk.deviceData;
		return null;
	}, [paypalSdk]);

	return function getDeviceData(paymentType) {
		if (paymentType !== 'paypal' || !deviceData) {
			return undefined;
		}
		return { deviceData };
	};
}
